import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApplicationId } from '../../lib';
import { ProductsService } from './services/products.service';

export function createProductsService(config: ApiPlanningProjectsConfig, http: HttpClient) {
    return new ProductsService(config, http);
}

export const API_PLANNING_PROJECTS_CONFIG = new InjectionToken<string>('API_PLANNING_PROJECTS_CONFIG');

export interface ApiPlanningProjectsConfig {
    apiBaseUrl: string;
    applicationId: ApplicationId;
}
